export default {
  date: "Date",
  id: "ID",
  interacs: "Interac",
  settings: "Settings",
  transactions: "Transactions",
  messageFrom: "From",
  messageSubject: "Subject",
  invoice: "Invoice",
  amount: "Amount",
  paymentDate: "Payment Date",
  invoiceIsPaidWarning:
    "This invoice is already paid. Are you sure you want to create this transaction?",
  transactionCreated: "Transaction created successfully.",
  grossAmount: "Gross Amount",
  netAmount: "Net Amount",
  processingFee: "Processing Fee",
  platformFee: "Platform Fee",
  sendReceipt: "Send Receipt",
  downloadReceipt: "Download Receipt",
  resendReceipt: "Resend Receipt",
  resendingReceipt: "Resending...",
  resendReceiptConfirmation:
    "Are you sure you want to resend this receipt? The email will be sent to the client with a PDF attachment.",
  receiptResent: "Receipt email has been queued for sending.",
  transactionActions: "Transaction actions",
};
